import React, { useState, useMemo } from 'react';
import _ from 'lodash';
import styled from 'styled-components/macro';

import { FormattedKoEnPhrase } from '@mirinae/lessons/components/lesson/elements/Phrase';
import Element from '@mirinae/lessons/components/lesson/elements/Element';
import { playTTS } from '@mirinae/lessons/modules/libs/lessonLib';

import ManHover from '@mirinae/lessons/assets/images/man-hovered.svg';
import ManPlaying from '@mirinae/lessons/assets/images/man-playing.svg';
import ManReady from '@mirinae/lessons/assets/images/man-ready.svg';
import WomanHover from '@mirinae/lessons/assets/images/woman-hovered.svg';
import WomanPlaying from '@mirinae/lessons/assets/images/woman-playing.svg';
import WomanReady from '@mirinae/lessons/assets/images/woman-ready.svg';

const TextAudioElement = styled(Element)`
    align-self: start;
    justify-content: start;
`;

const Sentence = styled.div`
    display: flex;
    flex-direction: row;
    cursor: pointer;
    align-items: center;
`;

const TextAudio = ({ element }) => {
    const [audioEl, setAudioEl] = useState(null);
    const [iconMode, setIconMode] = useState('ready');
    const [iconHover, setIconHover] = useState(false);
    const icons = {
        'Playing': () => (element.fieldsByName.gender.value === 'Female' ? <img src={WomanPlaying} alt="Woman playing" /> : <img src={ManPlaying} alt="Man playing" />),
        'Ready': () => (element.fieldsByName.gender.value === 'Female' ? <img src={WomanReady} alt="Woman ready" /> : <img src={ManReady} alt="Man ready" />),
        'Hover': () => (element.fieldsByName.gender.value === 'Female' ? <img src={WomanHover} alt="Woman hover" /> : <img src={ManHover} alt="Man hover" />),
    };

    const fullKoreanSentence = useMemo(() => _.reduce(
        element.fieldsByName.sentence.parts.koreanParts, (prev, curr) => prev + curr.value, '',
    ), [element]);

    return fullKoreanSentence && (
        <TextAudioElement element={element}>
            <Sentence 
                onClick={() => playTTS(audioEl, fullKoreanSentence, null, { speed: '80%', speaker: element.fieldsByName.gender.value.toLowerCase() })}
                onMouseOver={() => setIconHover(true)} 
                onMouseLeave={() => (iconHover ? setIconHover(false) : null)}
            >
                {iconMode === 'playing' ? <icons.Playing /> : iconMode === 'ready' ? iconHover ? <icons.Hover /> : <icons.Ready /> : <icons.Ready />}
                <FormattedKoEnPhrase phrase={element.fieldsByName.sentence} phraseStyle={{ ...element.style, padding: '0 0 0 15px', align: 'left' }} />
            </Sentence>
            <audio 
                ref={setAudioEl} 
                onPlay={() => setIconMode('playing')} 
                onPause={() => setIconMode('ready')} 
                onEnded={() => setIconMode('ready')} 
            />
        </TextAudioElement>
    );
};

export default TextAudio;
